/**
 * The gathering page's Carried panel: the entering character's carried slots
 * with the crystals they've coalesced from their banked essence (each one a
 * `StartingCrystalPick` the server holds and charges when the run starts).
 */
import type { EmpyrealCrystalItem } from '@sorrem/shared';
import type { UIInventoryItem } from '@sorrem-client/types';
import { toUICrystalItem } from '@sorrem-client/ui/shared/crystal-item';

/** Id prefix of a starting crystal stack in the preview; the slot index follows it. */
const STARTING_CRYSTAL_ID_PREFIX = 'starting-crystal:';

/**
 * A starting crystal stack as the inventory UI shows it, named by its slot so
 * a selection stays put while picks change.
 */
export function toUIStartingCrystal(item: EmpyrealCrystalItem, slotIndex: number): UIInventoryItem {
    return toUICrystalItem(item, `${STARTING_CRYSTAL_ID_PREFIX}${slotIndex}`);
}

/** Whether a preview item id is a starting crystal stack (not a piece of equipment). */
export function isStartingCrystalId(itemId: string): boolean {
    return itemId.startsWith(STARTING_CRYSTAL_ID_PREFIX);
}
